<template lang="pug">
    v-dialog( max-width="650px" v-model="open" )
        v-toolbar( color="primary" dark sticky flat )
            v-toolbar-title
                span {{ dynamicTittle }}
                v-spacer
                span {{ dynamicTittleBalance }}
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        v-container.pa-2( fluid )
            v-data-table(
                :headers="headersTable"
                :items="listDetail"
                no-data-text="Sin detalles contables"
                hide-actions
                )
                tr(slot="items" slot-scope="props")
                    template
                        td {{ props.item.debt | mixFormatCurrency }}
                        td {{ props.item.receive | mixFormatCurrency }}
                tr(slot="footer" )
                    template
                        td.font-weight-bold.subheading(
                            ) {{_debtTotal | mixFormatCurrency}}
                        td.font-weight-bold.subheading(
                            ) {{_receiveTotal | mixFormatCurrency}}
</template>

<script>
import HeadersTAccountTable from './HeadersTAccountTable'
import { CurrencyUtils } from '@/mixins/reusable_mixins'
export default {
    name: 'dialog-t-account',
    props: {
        tAccountObj: {
            type: Object,
            required: true,
        },
    },
    data: function() {
        return {
            open: false,
            listDetail: [],
            headersTable: HeadersTAccountTable,
        }
    },
    computed: {
        dynamicTittle: function() {
            return `${this.tAccountObj.acc_account.code} - ${this.tAccountObj.acc_account.comment}`
        },
        dynamicTittleBalance: function() {
            return this.tAccountObj.balance_str
        },
        _debtTotal: function() {
            let data = this.tAccountObj
            if (data.acc_debits.length > 0) {
                let totalDebits = data.acc_debits
                    .map(debit => parseFloat(debit.pivot.amount))
                    .reduce((total, debt) => total + debt)
                return totalDebits
            } else return 0
        },
        _receiveTotal: function() {
            let data = this.tAccountObj
            if (data.acc_credits.length > 0) {
                let totalCredits = data.acc_credits
                    .map(credit => parseFloat(credit.pivot.amount))
                    .reduce((total, credt) => total + credt)
                return totalCredits
            } else return 0
        },
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        getTAccountInfo: function() {
            let items = []
            let { acc_credits, acc_debits } = this.tAccountObj
            items = [
                ...acc_debits.map(deb => this.formatAccount(deb, 'debit')),
                ...acc_credits.map(cred => this.formatAccount(cred, 'credit')),
            ]
            this.listDetail = [...items]
        },
        // -- Data handling and transformations

        formatAccount: function(acc, type) {
            let { acc_account_id, amount } = acc.pivot
            let obj = {}
            if (type === 'debit') {
                obj.debt = amount
                obj.receive = 0
            } else {
                obj.debt = 0
                obj.receive = amount
            }
            return obj
        },
        // -- Validations and Error handling
        // -- Other functions
        toggleOpen: function() {
            this.open = !this.open
        },
        // -- Vuex mappings
    },
    watch: {
        open(val) {
            if (val == true) {
                // load info about account
                this.getTAccountInfo(this.tAccountObj)
            }
        },
    },
    // components: {},
    mixins: [CurrencyUtils],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>